import { render, staticRenderFns } from "./AlexsReport.vue?vue&type=template&id=4895fa7e"
import script from "./AlexsReport.vue?vue&type=script&lang=js"
export * from "./AlexsReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports